import { Observable } from 'rxjs';
import { BaseEntityService } from "./base-entity.service";
import { Injectable } from "@angular/core";

import { User, Role } from "./user.model";
import { AngularFirestore } from "@angular/fire/firestore";

@Injectable({
  providedIn: "root"
})
export class UserService extends BaseEntityService<User> {
  constructor(db: AngularFirestore) {
    super(db, User, "/", "users");
  }

  listWhereRole(role: Role): Observable<User[]> {
    return this.list(ref => ref.where('roles', 'array-contains', role));
  }
}
